// Sparkline — pure SVG line/area chart of a number array.

export interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  color?: string;
  area?: boolean;
  strokeWidth?: number;
  ariaLabel?: string;
}

export function Sparkline({
  values,
  width = 120,
  height = 32,
  color = "var(--md-primary)",
  area = true,
  strokeWidth = 1.75,
  ariaLabel,
}: SparklineProps) {
  if (!values.length) return <svg width={width} height={height} aria-hidden="true" />;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = values.length > 1 ? width / (values.length - 1) : width;
  const pad = strokeWidth;
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = pad + (1 - (v - min) / range) * (height - pad * 2);
    return [x, y] as const;
  });
  const line = points.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`).join(" ");
  const fill = area
    ? `${line} L${width.toFixed(2)},${height.toFixed(2)} L0,${height.toFixed(2)} Z`
    : null;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      {fill ? <path d={fill} fill={color} opacity={0.12} /> : null}
      <path d={line} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Sparkline;
